import * as React from 'react';
import { User, X } from 'lucide-react';
import { Button } from 'shared-portal-components-v2';

export interface SelectedPersonRowProps {
  name: string;
  email: string;
  onRemove: () => void;
}

export function SelectedPersonRow(props: SelectedPersonRowProps): React.JSX.Element {
  const { name, email, onRemove } = props;

  return (
    <div className="flex items-center justify-between p-3 bg-primary/5 border border-primary/20 rounded-lg">
      <div className="flex items-center space-x-3 min-w-0">
        <div className="w-8 h-8 bg-primary/10 rounded-full flex items-center justify-center shrink-0">
          <User className="h-4 w-4 text-primary" />
        </div>

        <div className="min-w-0">
          <div className="font-medium truncate">{name}</div>
          <div className="text-sm text-muted-foreground truncate">{email}</div>
        </div>
      </div>

      <Button
        type="button"
        variant="tertiary"
        size="icon"
        onClick={onRemove}
        className="rounded-md h-8 w-8 p-0 hover:bg-destructive/10 hover:text-destructive shrink-0"
        aria-label={`Remove ${name}`}
      >
        <X className="h-4 w-4" />
      </Button>
    </div>
  );
}

SelectedPersonRow.displayName = 'SelectedPersonRow';

export default SelectedPersonRow;
